module.exports = __webpack_public_path__ + "img/merit_icon2.1bb1c4af.png";